import React, { useState } from 'react'

import Lightbox from 'react-image-lightbox'

type GalleryProps = {
  images: any[]
}

const Gallery = ({ images }: GalleryProps) => {
  const [imageIndex, setImageIndex] = useState(0)
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false)

  const handleImageClick = (index: number) => {
    setImageIndex(index)
    setLightboxIsOpen(true)
  }

  return (
    <div className="gallery-wrapper">
      {images.map((image: any, index: number) => {
        return (
          <div className="img-container" key={`gallery-image-${index}`}>
            <div className="img-wrapper">
              <img
                className="image-thumbnail"
                src={`../${image.src}`}
                alt={image.alt}
                onClick={() => handleImageClick(index)}
              />
            </div>
          </div>
        )
      })}
      {lightboxIsOpen && (
        <Lightbox
          mainSrc={`../${images[imageIndex].src}`}
          nextSrc={`../${images[(imageIndex + 1) % images.length].src}`}
          prevSrc={`../${
            images[(imageIndex + images.length - 1) % images.length].src
          }`}
          onCloseRequest={() => setLightboxIsOpen(false)}
          onMovePrevRequest={() =>
            setImageIndex((imageIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setImageIndex((imageIndex + 1) % images.length)
          }
          imageCaption={images[imageIndex].caption}
          enableZoom={false}
          imagePadding={20}
        />
      )}
    </div>
  )
}

export default React.memo(Gallery)
